import { useMemo } from "react";
import { object } from "prop-types";
import { observer } from "mobx-react";
import { roundFloat, Rounding } from "@repo/utils";
import { CELL_WIDTHS } from "@utils";
import { useEstimateStructure, ValueCell, CollapseValueCell } from "@tools";
import { useBudgetTrackingStore } from "@views/Projects/BudgetTracking/providers/BudgetTrackingStore";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";

export const HoursCell = observer(({ workType }) => {
  const structure = useEstimateStructure();
  const { hours } = useBudgetTrackingStore();
  const classes = useStyle();

  const { useMinMax, modifier, usedDecimals } = structure.settings;
  const {
    parsedHours,
    displayBTHours,
    // hasCustomHours,
    btHourDiff,
    btHourDiffPercent,
  } = workType;

  const colorText = useMemo(() => {
    if (parsedHours.avg !== 0) {
      return btHourDiff.avg > 0 ? classes.rowAccepted : classes.rowDanger;
    }
    return null;
  }, [parsedHours.avg, btHourDiff.avg]);

  const value = useMemo(
    () =>
      roundFloat(
        useMinMax ? parsedHours.max || 0 : parsedHours.avg || 0,
        Rounding.FULL,
        false,
        usedDecimals
      ),
    [ parsedHours, useMinMax, usedDecimals ]
  );

  const btHourDiffPercents = useMemo(
    () =>
      roundFloat(
        useMinMax ? btHourDiffPercent.max || 0 : btHourDiffPercent.avg || 0,
        Rounding.FULL,
        false,
        usedDecimals
      ),
    [ useMinMax, useMinMax ]
  );

  const btHourDiffs = useMemo(
    () =>
      roundFloat(
        (useMinMax ? btHourDiff.max || 0 : btHourDiff.avg || 0) / modifier,
        Rounding.FULL,
        false,
        usedDecimals
      ),
    [useMinMax, useMinMax]
  );

  return (
    <CollapseValueCell
      childrenWidth={CELL_WIDTHS.VALUE.XXSMALL}
      mainCellWidth={CELL_WIDTHS.VALUE.LARGE}
      isOpened={hours}
      cell={
        <ValueCell
          size="large"
          value={btHourDiffPercents}
          symbolEnd="%"
          displayContent
          showDecimals
          // warning={hasCustomHours}
          textPresetClass={classnames("preset-summaryText", colorText)}
          useSeparator
        />
      }
    >
      <ValueCell
        size="xsmall"
        displayContent
        value={value}
        useInputBackground
        usePriceFormat
        textPresetClass="preset-price"
      />
      <ValueCell
        size="xsmall"
        value={displayBTHours || 0}
        displayContent
        showDecimals
        // warning={hasCustomHours}
        textPresetClass={colorText}
      />
      <ValueCell
        size="xsmall"
        value={btHourDiffs}
        displayContent
        showDecimals
        // warning={hasCustomHours}
        textPresetClass={colorText}
        showValueSign
      />
      <ValueCell
        size="xsmall"
        value={btHourDiffPercents}
        displayContent
        showDecimals
        // warning={hasCustomHours}
        symbolEnd="%"
        textPresetClass={colorText}
        showValueSign
      />
    </CollapseValueCell>
  );
});

HoursCell.propTypes = {
  workType: object.isRequired,
};

const useStyle = makeStyles(() => ({
  cell: {
    zIndex: 2,
  },
  rowDanger: {
    color: "#41BD56",
  },
  rowAccepted: {
    color: "#DE0909",
  },
}));
